import { render, staticRenderFns } from "./goodsTicketConfig.vue?vue&type=template&id=58da909c&"
import script from "./goodsTicketConfig.vue?vue&type=script&lang=js&"
export * from "./goodsTicketConfig.vue?vue&type=script&lang=js&"
import style0 from "./goodsTicketConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58da909c')) {
      api.createRecord('58da909c', component.options)
    } else {
      api.reload('58da909c', component.options)
    }
    module.hot.accept("./goodsTicketConfig.vue?vue&type=template&id=58da909c&", function () {
      api.rerender('58da909c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/ticketManage/goodsTicketConfig/goodsTicketConfig.vue"
export default component.exports